const cardOne = {
  title: 'Get the home you really want',
  subtitle: "We'll help you max your borrowing power.",
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-borrow-lg.png)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-borrow-modal-lg.png',
    mobile: '/next-assets/carousel/cvp-borrow-modal-sm.png',
  },
  modalContent: [
    {
      heading: 'More power to you',
      paragraph: <>Our policies are far friendlier so you can borrow more.</>,
    },
    {
      heading: 'Calculate fast',
      paragraph: <>See what you can borrow in 3 minutes.</>,
    },
    {
      heading: 'Workshop your numbers',
      paragraph: <>With a Home Loan Expert so you can see if you can borrow more.</>,
    },
  ],
};

const cardTwo = {
  title: 'Pounce on auction day',
  subtitle: 'Get pre-approved fast.',
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-bidready-lg.png)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-bidready-modal-lg.png',
    mobile: '/next-assets/carousel/cvp-bidready-modal-sm.png',
  },
  modalContent: [
    {
      heading: "Don't miss out",
      paragraph: <>We&rsquo;ll get you pre-approved in days so you can get serious.</>,
    },
    {
      heading: 'Bid with confidence',
      paragraph: <>Our pre-approval is more accurate because it&rsquo;s fully credit assessed.</>,
    },
    {
      heading: '90 day pre-approval',
      paragraph: <>Your season pass to house-hunting. If rates change, your borrowing power won&rsquo;t go down.</>,
    },
  ],
};

const cardThree = {
  title: (
    <>
      We save,
      <br />
      not sting
    </>
  ),
  subtitle: 'Loan options with no fees, no loyalty tax and a rate you can drop.',
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-sleepsoundly-lg.jpg)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-sleepsoundly-modal-lg.jpg',
    mobile: '/next-assets/carousel/cvp-sleepsoundly-modal-sm.jpg',
  },
  modalContent: [
    {
      heading: 'Drop your own rate',
      paragraph: (
        <>
          With AcceleRATES, we&apos;ll drop your rate as you pay down your Straight Up or Power Up home loan
          <sup>2</sup>.
        </>
      ),
    },
    {
      heading: 'Loyalty is royalty',
      paragraph: (
        <>
          Existing and new customers score the same sexy rates on like-for-like loans
          <sup>3</sup> with our Automatic Rate Match.
        </>
      ),
    },
    {
      heading: 'No Athena fees',
      paragraph: (
        <>
          Our Straight Up and Power Up loans have zero Athena fees
          <sup>1</sup>!
        </>
      ),
    },
  ],
};

const cardFour = {
  title: 'Apply in minutes',
  subtitle: 'With helpful humans at the ready.',
  /* Image for the carousel */
  backgroundImage: 'url(/next-assets/carousel/cvp-congrats-lg.png)',
  /* Images passed to modals */
  image: {
    desktop: '/next-assets/carousel/cvp-congrats-modal-lg.png',
    mobile: '/next-assets/carousel/cvp-congrats-modal-sm.png',
  },
  modalContent: [
    {
      heading: 'Speed',
      paragraph: <>Apply in 15 minutes and get conditional approval in seconds.</>,
    },
    {
      heading: 'Ease',
      paragraph: (
        <>
          Our multi-award winning tech means you can apply fast, online. Talk with our Loan Experts who can do your
          application with you.
        </>
      ),
    },
    {
      heading: 'Expertise',
      paragraph: <>Talk to or text your dedicated Home Loan Experts who really know their stuff.</>,
    },
  ],
};

export const carouselCardContent = [cardOne, cardTwo, cardThree, cardFour];
